
    import './styles.scoped.css';
    export default {
  "pages-compact-text": "awsui_pages-compact-text_lmd86_117ep_5"
};
  